module.exports = __webpack_public_path__ + "img/tutorial_img_2_2.952bef66.png";